// extracted by mini-css-extract-plugin
module.exports = {"srOnly":"DashboardLock__srOnly--2izR9","hiddenInput":"DashboardLock__hiddenInput--VFl4q","root":"DashboardLock__root--19Gll"};